<template>
  <div class="processingFee">
    <!-- 条件查询 -->
    <div class="search">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="加工服务">
          <el-select v-model="searchForm.processingService" placeholder="请选择加工服务">
            <el-option v-for="item in ['熬药', '打粉', '丸剂', '制膏', '加工-YL']" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="$refresh(getProcessingsList, true)">查询</el-button>
          <el-button icon="el-icon-refresh" @click="$reset(getProcessingsList, { processingName: '' })">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作按钮 -->
    <div class="button">
      <el-button icon="el-icon-plus" type="primary" @click="addProcessing">新增规则</el-button>
    </div>
    <!-- 加工费收费规则列表 -->
    <el-table v-loading="loading" ref="multipleTable" :max-height="tableHeight" :data="processingList" style="margin: 12px 0 0 0; width: 100%;" border>
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="processingService" label="加工服务" min-width="80" />
      <el-table-column prop="processingType" label="加工方式" min-width="80" />
      <el-table-column prop="rules" label="收费规则" min-width="450" />
      <el-table-column prop="dictDrugCode" label="医保编码" min-width="160" />
      <el-table-column prop="createTime" label="创建时间" min-width="160" />
      <el-table-column label="操作" width="230">
        <template slot-scope="scope">
          <el-button icon="el-icon-edit" type="primary" @click="editProcessing(scope.row)">编辑规则</el-button>
          <el-button icon="el-icon-delete" type="primary" @click="deleteProcessing(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 新增或编辑弹框 -->
    <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="430px"
      :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="80px" inline>
        <el-form-item label="加工服务" prop="processingService">
          <el-select v-model="editForm.processingService" clearable placeholder="请选择加工服务">
            <el-option v-for="item in ['熬药', '打粉', '丸剂', '制膏', '加工-YL']" :key="item" :label="item" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="加工方式" prop="processingType">
          <el-radio-group v-if="editForm.processingService == '熬药'" v-model="editForm.processingType">
            <el-radio v-for="item in ['熬药']" :key="item" :label="item" />
          </el-radio-group>
          <el-radio-group v-if="editForm.processingService == '打粉'" v-model="editForm.processingType">
            <el-radio v-for="item in ['粗粉', '细粉']" :key="item" :label="item" />
          </el-radio-group>
          <el-radio-group v-if="editForm.processingService == '丸剂'" v-model="editForm.processingType">
            <el-radio v-for="item in ['水丸', '蜜丸']" :key="item" :label="item" />
          </el-radio-group>
          <el-radio-group v-if="editForm.processingService == '制膏'" v-model="editForm.processingType">
            <el-radio :label="'制膏'" />
          </el-radio-group>
          <el-radio-group v-if="editForm.processingService == '加工-YL'" v-model="editForm.processingType">
            <el-radio :label="'加工-YL'" />
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收费规则" prop="priceType">
          <el-radio-group v-model="editForm.priceType">
            <el-radio v-for="item in [{ value: '1', label: '阶梯收费' }, { value: '0', label: '固定收费' }]" :key="item.value"
              :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="固定价格" prop="fixedPrice" class="bn" v-if="editForm.priceType == 0">
          <el-input v-model.number="editForm.fixedPrice" placeholder="请输入固定价格">
            <template slot="prepend">每单加工费</template>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <!-- 阶梯收费 -->
        <div v-if="editForm.priceType == 1">
          <el-form-item label="计费条件" prop="ladderType">
            <el-radio-group v-model="editForm.ladderType">
              <el-radio v-for="item in [{ value: '0', label: '药品付数' }, { value: '1', label: '药品重量' }]" :key="item.value"
                :label="item.value">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="基础数量" prop="fixedNumber">
            <el-input v-model.number="editForm.fixedNumber" placeholder="请输入基础数量">
              <template slot="append" v-if="editForm.ladderType == '0'">付</template>
              <template slot="append" v-if="editForm.ladderType == '1'">g</template>
            </el-input>
          </el-form-item>
          <el-form-item label="基础价格" prop="fixedPrice">
            <el-input v-model="editForm.fixedPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入基础价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="递增数量" prop="beyondNumber">
            <el-input v-model.number="editForm.beyondNumber" placeholder="请输入递增数量">
              <template slot="append" v-if="editForm.ladderType == '0'">付</template>
              <template slot="append" v-if="editForm.ladderType == '1'">g</template>
            </el-input>
          </el-form-item>
          <el-form-item label="递增价格" prop="beyondPrice">
            <el-input v-model="editForm.beyondPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入递增价格">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
        <!-- 袋数超量费用 -->
        <div v-if="editForm.processingService == '熬药'">
          <el-form-item label="基础袋数" prop="bagFreeNumber" class="bn">
            <el-input v-model.number="editForm.bagFreeNumber" placeholder="请输入基础袋数">
              <template slot="prepend">每付药</template>
              <template slot="append">袋</template>
            </el-input>
          </el-form-item>
          <el-form-item label="超量价格" prop="bagPrice" class="bn">
            <el-input v-model="editForm.bagPrice" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="超量价格">
              <template slot="prepend">每付药多加 1 袋，加</template>
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <!-- 操作按钮 -->
      <span slot="footer" class="dialog-footer">
        <el-button type="success" v-if="dialogTitle == '新增加工费收费规则'" @click="addSave">保存新增</el-button>
        <el-button type="success" v-if="dialogTitle == '编辑加工费收费规则'" @click="editSave">保存修改</el-button>
        <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 分页 -->
    <el-pagination
      @current-change="page => $handleCurrentChange(page, getProcessingsList)"
      :total="total"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
  import { processingList, processingEdit, processingAdd, processingDelete } from "@/api/processing"
  export default {
    name: 'processingFee',
    data() {
      return {
        loading: true, // 加载中
        searchForm: { processingService: null }, // 查询表单
        processingList: [], // 加工费收费规则列表
        currentPage: 1, // 当前页
        pageSize: 10, // 显示条数
        total: 0, // 总条数
        dialogTitle: null, // 弹框标题
        dialogVisible: false, // 新增或编辑弹框状态
        editForm: {}, // 新增或编辑表单
        editFormRules: {
          processingService: [{ required: true, message: "加工服务不能为空！", trigger: "change" }],
          processingType: [{ required: true, message: "加工方式不能为空！" }],
          priceType: [{ required: true }],
          ladderType: [{ required: true }],
          fixedPrice: [{ required: true, message: "基础价格不能为空！" }],
          fixedNumber: [{ required: true, message: "基础数量不能为空！" }, { type: 'number', message: "数量为整数格式！" }],
          beyondPrice: [{ required: true, message: "递增价格不能为空！" }],
          beyondNumber: [{ required: true, message: "递增数量不能为空！" }, { type: 'number', message: "数量为整数格式！" }],
          bagFreeNumber: [{ required: true, message: "基础袋数不能为空！" }, { type: 'number', message: "数量为整数格式！" }],
          bagPrice: [{ required: true, message: "袋子价格不能为空！" }],
        }, // 验证规则
        tableHeight: 0
      }
    },
    created() {
      this.tableHeight = document.documentElement.clientHeight - 330;
      this.getProcessingsList(); // 页面初始化获取加工费收费规则列表
    },
    methods: {
      // 请求所有加工费收费规则列表
      async getProcessingsList() {
        let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
        let { total, rows, code } = await processingList(params);

        if (code == 200) {
          this.total = total;
          rows.forEach(item => {
            let rules = "";
            if (item.priceType == '0') {
              rules = `固定价格，每单加工费 ${item.fixedPrice} 元`
              if (item.processingService == "熬药") rules += `(超额：每付 ${item.bagFreeNumber} 袋，每加 1 袋加 ${item.bagPrice} 元)`
            } else {
              let unit = item.ladderType == '0' ? "付" : "g";
              rules = `递增价格，每单 ${item.fixedNumber} ${unit}内加工费 ${item.fixedPrice} 元，每加 ${item.beyondNumber} ${unit}加 ${item.beyondPrice} 元`
              if (item.processingService == "熬药") rules += `(超额：每付 ${item.bagFreeNumber} 袋，每加 1 袋加 ${item.bagPrice} 元)`
            }
            item.rules = rules;
          });
          this.processingList = rows;
        }
        this.loading = false;
      },
      // 新增加工费收费规则
      addProcessing() {
        this.dialogVisible = true;
        this.dialogTitle = "新增加工费收费规则";
        this.editForm = {
          processingService: "熬药", processingType: '熬药', priceType: '0', fixedPrice: null, ladderType: '0',
          fixedNumber: null, beyondNumber: null, beyondPrice: null, bagFreeNumber: null, bagPrice: null, deptId: this.$session.get('deptId')
        };
      },
      // 保存新增
      addSave() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            processingAdd(this.editForm).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("新增加工费收费规则成功！");

              this.dialogVisible = false;
              this.$refresh(this.getProcessingsList);
              this.$refs['editForm'].resetFields();
            })
          } else return false;
        })
      },
      // 编辑加工费收费规则信息
      async editProcessing(row) {
        this.editForm = JSON.parse(JSON.stringify(row));
        this.dialogTitle = "编辑加工费收费规则";
        this.dialogVisible = true;
      },
      // 保存加工费收费规则修改
      editSave() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            processingEdit(this.editForm).then(res => {
              let { code } = res;
              if (code == 200) this.$message.success("修改加工费收费规则成功！");

              this.dialogVisible = false;
              this.$refresh(this.getProcessingsList);
              this.$refs['editForm'].resetFields();
            })
          } else return false;
        })
      },
      //删除加工规则
      async deleteProcessing(row) {
        let { code, data } = await processingDelete(row.processingRulesId)
        if (code == 200) {
          this.$message.success("删除成功！");
          this.$refresh(this.getProcessingsList);
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .processingFee {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .dialogEdit /deep/ .el-input, .dialogEdit /deep/ .el-form-item__content {
    width: 300px !important;
  }

  .dialogEdit /deep/ .el-input-group__append {
    width: 50px;
    padding: 0;
    text-align: center;
  }

  .dialogEdit .bn /deep/ .el-input-group__prepend, .dialogEdit .bn /deep/ .el-input-group__append {
    background-color: #fff;
    border: none;
    color: #606266;
    font-size: 14px;
    padding: 0 5px;
  }

  .dialogEdit .bn /deep/ .el-input__inner {
    border: none;
    border-bottom: 1px solid #DCDFE6;
  }
</style>
